"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../../media/icon/Icon");
var _BaseColumn = require("./support/BaseColumn");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../../shared/tokens/tokens"));
var _2 = require("../../..");
var _InnerButton = require("../../../controls/buttons/InnerButton");
var _jsxRuntime = require("react/jsx-runtime");
var ClickableText = (0, _styledComponents.default)(_InnerButton.NonVisualButton).withConfig({
  displayName: "TextColumn__ClickableText",
  componentId: "sc-10eaqhc-0"
})(["cursor:pointer;"]);
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "TextColumn__IconWrapper",
  componentId: "sc-10eaqhc-1"
})(["max-height:", ";"], _tokens.default.sky.sys.size.icon['2']);
var TextColumn = function TextColumn(_) {
  return null;
};
TextColumn.toColumnDef = function (child) {
  var props = child.props;
  var accessorKey = props.accessorKey,
    defaultGroupingValue = props.defaultGroupingValue;
  return _objectSpread({}, (0, _BaseColumn.defaultColumnDef)(child.props), {
    accessorKey: accessorKey,
    cell: function cell(_ref) {
      var _props$disabled, _props$alert;
      var row = _ref.row,
        column = _ref.column,
        getValue = _ref.getValue;
      var tooltip = undefined;
      var editable = undefined;
      var icon = undefined;
      var disabled = ((_props$disabled = props.disabled) === null || _props$disabled === void 0 ? void 0 : _props$disabled.call(props, row.original)) || false;
      var ellipsis = !!props.ellipsis;
      var onClick = props.onClick;
      var alert = ((_props$alert = props.alert) === null || _props$alert === void 0 ? void 0 : _props$alert.call(props, row.original)) || false;
      var onClickFunction = onClick && onClick(row.original);
      var color = disabled ? 'disabled' : onClickFunction ? 'link' : alert ? 'error' : 'default';
      var value = getValue();
      if (props.icon && (column.getIsGrouped() || !row.getIsGrouped())) {
        icon = props.icon(row.original);
      }
      if (props.editable) {
        if (props.editable(row.original)) {
          editable = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            icon: 'edit'
          });
        }
      }
      if (props.tooltip) {
        tooltip = props.tooltip(row.original);
      }
      var cellValue = value ? value : row.getIsGrouped() ? defaultGroupingValue : '';
      var iconElement = icon ? /*#__PURE__*/(0, _jsxRuntime.jsx)(IconWrapper, {
        children: icon
      }) : undefined;
      return (0, _BaseColumn.styledCell)(child.props, /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [!props.alignIconRight && iconElement, onClickFunction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(ClickableText, {
          onClick: onClickFunction,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_2.Text, {
            ellipsis: ellipsis,
            tooltipOnEllipsis: ellipsis,
            size: '2',
            color: color,
            underline: true,
            noWrap: !ellipsis,
            children: cellValue
          })
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_2.Text, {
          ellipsis: ellipsis,
          tooltipOnEllipsis: ellipsis,
          size: '2',
          color: color,
          noWrap: !ellipsis,
          children: cellValue
        }), editable, !!props.alignIconRight && iconElement, !!tooltip && /*#__PURE__*/(0, _jsxRuntime.jsx)(_2.IconTooltip, {
          icon: 'help',
          children: tooltip
        })]
      }));
    },
    footer: function footer() {
      if (props.footer !== undefined) {
        var value = props.footer;
        return (0, _BaseColumn.styledCell)(child.props, value);
      }
      return null;
    }
  });
};
var _default = exports.default = TextColumn;